import {Component, Input, OnInit} from '@angular/core';
import {CommonUtils} from "../../utils/common";
import {AppStateService} from "../../providers/app-state.service";
import {Client} from "../../models/client.model";
import {GdprTermsService} from "../../providers/gdpr-terms.service";
import {GdprTerms} from "../../models/gdpr-terms.model";
import {ModalController} from "@ionic/angular";
import {GdrpAcceptanceData} from "../../models/gdrp-acceptance-data.model";
import {AuthService} from "../../providers/auth.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-gdpr-term-placeholder',
  templateUrl: './gdpr-term-placeholder.component.html',
  styleUrls: ['./gdpr-term-placeholder.component.scss'],
})
export class GdprTermPlaceholderComponent implements OnInit {
  @Input()
  gdrpTerms: string;
  @Input()
  mode: string;
  @Input()
  gdpr: GdprTerms;
  @Input()
  vClientData: Client;

  gdrpToAccept: GdprTerms;
  showTerms: boolean = false;
  isAccepted: boolean = false;
  isBusy: boolean;
  @Input()
  acceptanceDate: string;
  @Input()
  generatedDate: string;
  printPdfSub: Subscription;

  constructor(public commonUtils: CommonUtils, private appStateService: AppStateService, private authService: AuthService,
              private gdprTermsService: GdprTermsService, private modalController: ModalController) {
  }

  ngOnInit() {
    this.appStateService.isBusySubject.subscribe(e => {
      this.isBusy = e;
    })

    this.gdrpToAccept = new GdprTerms();
    this.gdrpToAccept.vClientUUID = this.vClientData.uuid;
    this.gdrpToAccept.jsonValue = JSON.stringify(this.prepareJsonData())
    this.gdrpToAccept.template = this.gdrpTerms;
    this.replace();

  }

  print() {
    this.appStateService.updateIsBusySubject(true);
    this.printPdfSub = this.gdprTermsService.printGdprPdf(this.vClientData.uuid, this.gdpr.uuid).subscribe(signedUrl => {
        this.appStateService.updateIsBusySubject(false);
        if (signedUrl) {
          window.open(signedUrl, '_blank');
        } else {
          this.commonUtils.presentAlertToast('Wystąpił błąd podczas pobieranie umowy powierzenia danych w formacie PDF');
        }
      }, error => {
        this.appStateService.updateIsBusySubject(false);
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas pobieranie umowy powierzenia danych w formacie PDF');
      });

  }


  replace() {
    this.gdrpTerms = this.gdrpTerms.replace('#DATE#', this.commonUtils.simpleDateFromString(this.acceptanceDate));
    this.gdrpTerms = this.gdrpTerms.replace('#CLIENT_DATA#', this.prepareClientDataText());
    this.gdrpTerms = this.gdrpTerms.replace('#GENERATED_DATE#', this.commonUtils.simpleDateFromString(this.generatedDate));
    this.showTerms = true;
  }

  onToggleAccept() {
    this.isAccepted = !this.isAccepted;
  }

  save() {
    if (this.isAccepted) {
      this.commonUtils.presentYesNoActionSheet('Czy potwierdzasz umowę powierzenia przetwarzania danych osobowych?', 'Tak', 'Nie', 'checkmark',
        'close', () => {
          this.gdrpToAccept.value = this.gdrpTerms;
          this.appStateService.updateIsBusySubject(true);
          this.gdprTermsService.acceptTerms(this.gdrpToAccept).subscribe(e => {
            if (e) {
              this.commonUtils.presentInfoToast('Dziękujemy za potwierdzenie umowy powierzenia przetwarzania danych osobowych. Za chwilę zostaną Państwo wylogowani - jest to niezbędne w celu dokończenia procesu aktywacji umowy.', 'bottom', 8000).then(() => {
                this.appStateService.updateIsBusySubject(true);

                setTimeout(() => {
                  this.modalController.dismiss(this.gdrpTerms).then(() => {
                    this.authService.logout();
                  });
                }, 8000);
              });
            } else {
              this.commonUtils.presentAlertToast('Wystąpił błąd podczas potwierdzania umowy');
            }
            this.appStateService.updateIsBusySubject(false);
          }, err => {
            this.commonUtils.presentAlertToast('Wystąpił błąd podczas potwierdzania umowy');
            this.appStateService.updateIsBusySubject(false);
          });
        }, () => {
        });
    } else {
      this.commonUtils.presentAlertToast('Nie można zapisać umowy powierzenia przetwarzania danych osobowych');
    }
  }

  cancel() {
    this.modalController.dismiss(null).then(() => {
    });
  }


  private prepareJsonData() {
    let gdrpJson = new GdrpAcceptanceData();
    gdrpJson.acceptanceDate = this.acceptanceDate;
    gdrpJson.city = this.vClientData.city;
    if (this.vClientData.krs) {
      gdrpJson.krs = this.vClientData.krs;
    }
    gdrpJson.regon = this.vClientData.regon;
    gdrpJson.taxId = this.vClientData.taxId;
    gdrpJson.name = this.vClientData.name;
    gdrpJson.postalCode = this.vClientData.postalCode;
    gdrpJson.streetWithNumber = this.vClientData.streetWithNumber
    gdrpJson.signingDate = this.generatedDate;
    return gdrpJson;
  }

  private prepareClientDataText() {
    if (this.vClientData.krs) {
      return `${this.vClientData.name} z siedzibą ul.${this.vClientData.streetWithNumber}, ${this.vClientData.postalCode} ${this.vClientData.city}, nr KRS: ${this.vClientData.krs}, NIP: ${this.vClientData.taxId}, REGON: ${this.vClientData.regon}`;
    } else {
      return `${this.vClientData.name} z siedzibą ul.${this.vClientData.streetWithNumber}, ${this.vClientData.postalCode} ${this.vClientData.city}, NIP: ${this.vClientData.taxId}, REGON: ${this.vClientData.regon}`;
    }
  }
}
